__turbopack_context__.v({
  "handle": "priceFilter-module-scss-module__o7Co4a__handle",
  "rail": "priceFilter-module-scss-module__o7Co4a__rail",
  "slider": "priceFilter-module-scss-module__o7Co4a__slider",
  "sliderWrapper": "priceFilter-module-scss-module__o7Co4a__sliderWrapper",
  "track": "priceFilter-module-scss-module__o7Co4a__track",
  "values": "priceFilter-module-scss-module__o7Co4a__values",
});
